import { render, staticRenderFns } from "./OrganizationItem.vue?vue&type=template&id=7b8eea40&lang=pug&"
import script from "./OrganizationItem.vue?vue&type=script&lang=js&"
export * from "./OrganizationItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports